export default class Constants {
  static GITHUB_LINK = 'https://github.com/jorgetobarra';

  static LINKEDIN_LINK = 'https://www.linkedin.com/in/jorge-tobarra/';
}

export const PORTFOLIO_LINKS = {
  cvonline: {
    link: 'https://www.tobarrajorge.com',
    youtube: '',
  },
  diceandroll: {
    link: 'https://diceandroll.delbuey.com/',
    github: 'https://github.com/jorgetobarra/diceandroll',
    youtube: 'XJ8j3d5ikIo',
  },
  spotivision: {
    github: 'https://github.com/jorgetobarra/spotivision-next',
    youtube: 'pEl4xWZT6cY',
  },
  myScorewiz: {
    github: 'https://github.com/jorgetobarra/my_scorewiz',
    youtube: 'z2RZuYX6LQ8',
  },
} as const;

export const LANGUAGES = [
  { name: 'Español', code: 'es' },
  { name: 'English', code: 'en' },
];
